import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { ScrollerSectionType01Component } from "../../../../modules/client/scroller-section/scroller_section-type01/scroller_section-type01.component";
import { BannerSectionType01Component } from "../../../../modules/client/banner-section/banner_section-type01/banner_section-type01.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChangeGameType01Component } from "../../../../modules/client/change-game/change-game-type01/change-game-type01.component";


@Component({
  selector: 'app-holidays',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink, ScrollerSectionType01Component, BannerSectionType01Component, MatIconModule, MatTooltipModule, ChangeGameType01Component],
  templateUrl: './holidays.component.html',
  styleUrl: './holidays.component.scss'
})
export class HolidaysComponent implements OnInit {

  public view: any = {
    title: 'Our Solutions',
    page: {}
  }

  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef, private route: ActivatedRoute){

    this.route.params.subscribe(res => {
      this.view.features = [];
      this.view.features.push({icon:"heroicons_outline:currency-dollar", title:"Accommodation", text:"Transforming the way you book accommodations with curated options that match your style, budget, and preferences."});
      this.view.features.push({icon:"heroicons_outline:building-storefront", title:"Dynamic Packages", text:"Simplifying group travel with tailored itineraries, seamless coordination, and exclusive group discounts."});
      this.view.features.push({icon:"heroicons_outline:building-storefront", title:"Tour Packages", text:"Redefining tour packages by offering flexible, customizable experiences that cater to individual interests and needs."});
      this.view.features.push({icon:"heroicons_outline:building-storefront", title:"Luxury Travel", text:"Elevating luxury travel with exclusive experiences, personalized service, and access to elite destinations."});
      this.view.features.push({icon:"heroicons_outline:building-storefront", title:"Realtime Pricing", text:"Delivering up-to-the-minute pricing and availability with advanced tools that ensure you get the best rates instantly, combined with seamless booking and cost-saving solutions."});
      this.view.features.push({icon:"heroicons_outline:building-storefront", title:"Instant Booking", text:"Revolutionizing the booking process with real-time confirmations, ensuring immediate reservations and availability for a hassle-free travel experience."});
      // this.view.slug = res.slug.toLowerCase();

      // this._tfmService.getPages().then((resPages:any) => {
      //   var pages = resPages.content.filter(x=>x.seo.alias.toLowerCase() == this.view.slug);
      //   if (pages.length == 1) {
      //     this.view.page = pages[0];
          
      //     // this._tfmService.log(this.view);
      //   }
      // });
    });
  }

  ngOnInit(): void {
  }

}
